'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function (root, factory) {
    if (typeof module !== 'undefined' && module.exports !== undefined) {
        module.exports = factory();
    } else if (typeof define !== 'undefined' && define.amd) {
        define('INumber', [], function () {
            return factory();
        });
    } else {
        root.INumber = factory();
    }
})(window || module || {}, function () {
    var INumber = function () {
        function INumber(val) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            _classCallCheck(this, INumber);

            var parsedValue = NaN;

            this.fractionPointer = options.fractionPointer || '.';
            this.thousandPointer = options.thousandPointer || ' ';
            this.htmlTag = options.htmlTag || 'small';
            this.floatKey = options.floatKey || 'float';
            this.intKey = options.intKey || 'int';
            this.fractionKey = options.fractionKey || 'fraction';

            if (typeof val === 'number') {
                parsedValue = Number(val);
            } else if (val instanceof INumber) {
                this[this.floatKey] = val[this.floatKey];
                this[this.intKey] = val[this.intKey];
                this[this.fractionKey] = val[this.fractionKey];
                return this;
            } else if (typeof val === 'string') {
                parsedValue = this._parse(val);
            }

            this._setValue(parsedValue);

            return this;
        }

        /**
         * Get full number string
         * @param {string|null} fractionPointer : null || '.'
         * @param {string|null} thousandPointer : null || ' '
         * @param {boolean} shortFormat : true || false
         * @param {boolean} toFixed : boolean. if true, return 1 522 from 1522.00
         * @param {boolean} toABS : false return 1.00 from -1.00
         * @return {string}
         */


        _createClass(INumber, [{
            key: 'toString',
            value: function toString(fractionPointer, thousandPointer) {
                var shortFormat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                var toFixed = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
                var toABS = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

                if (isNaN(this[this.fractionKey])) {
                    return '';
                }

                thousandPointer = thousandPointer !== null && thousandPointer !== undefined ? thousandPointer : this.thousandPointer;
                shortFormat = shortFormat && !this[this.fractionKey];
                toFixed = toFixed !== false ? toFixed : 2;

                var float = toABS ? Math.abs(this[this.floatKey]) : this[this.floatKey],
                    string = float.toFixed(shortFormat ? 0 : toFixed),
                    intRegexp = void 0,
                    intString = void 0,
                    intArr = [];

                if (fractionPointer) {
                    string = string.replace(/\./, String(fractionPointer));
                }

                // Добавляем разделители для тысячных
                if (this[this.floatKey] >= 1000 || this[this.floatKey] <= -1000) {
                    // выделяет целую часть числа из строки
                    intRegexp = new RegExp('([0-9]*)(\\' + (fractionPointer || this.fractionPointer) + '|$)');
                    intString = intRegexp.exec(string);
                    intString = intString ? intString[1] : '';

                    var subPosition = 0,
                        length = intString.length * -1,
                        breaker = true,
                        step = 3;

                    /** перебор строки целого числа (123456) с конца, с шагом 3
                     * если число кратное 3м, то последний проход цикла будет в холостую
                     * в противном случае в последней итерации будет взят остаток
                     * который остался после выбора всех трехзначных блоков
                     */
                    while (breaker) {
                        subPosition -= 3;
                        if (subPosition <= length) {
                            step = length * -1 - intArr.length * 3;
                            subPosition = length;
                            breaker = false;
                        }
                        intArr.unshift(intString.substr(subPosition, step));
                    }

                    // целая часть числа заменяется новой с разделителями, добавляетя дробная часть
                    string = string.replace(intRegexp, intArr.join(thousandPointer) + '$2');
                }

                return string;
            }
        }, {
            key: 'intString',
            value: function intString() {
                return this.toString(null, null, false).replace(/\.[\d]+/, '');
            }
        }, {
            key: 'fractionString',
            value: function fractionString(fractionPointer) {
                var shortFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

                var result = '';

                fractionPointer = !fractionPointer ? this.fractionPointer : fractionPointer;

                if (this[this.fractionKey]) {
                    result = fractionPointer + String(this[this.fractionKey]).replace(/^[\d-]+\./, '');
                } else {
                    result = shortFormat ? '' : fractionPointer + String(this[this.fractionKey]).replace(/^[\d-]+\./, '');
                }

                return result;
            }

            /**
             * Get Float
             * @return {number}
             */

        }, {
            key: 'toFloat',
            value: function toFloat() {
                return this[this.floatKey];
            }

            /**
             * @return {number}
             */

        }, {
            key: 'toInteger',
            value: function toInteger() {
                return this[this.intKey];
            }

            /**
             * @return {boolean}
             */

        }, {
            key: 'isNegative',
            value: function isNegative() {
                return this[this.floatKey] < 0;
            }

            /**
             * @return {INumber}
             */

        }, {
            key: 'getAbs',
            value: function getAbs() {
                return new INumber(Math.abs(this[this.floatKey]));
            }

            /**
             * @return {INumber}
             */

        }, {
            key: 'getInverted',
            value: function getInverted() {
                return new INumber(-1 * this[this.floatKey]);
            }
        }, {
            key: 'getFraction',
            value: function getFraction() {
                return this[this.fractionKey];
            }

            /**
             * @return {Boolean}
             */

        }, {
            key: 'validate',
            value: function validate() {
                return !isNaN(this[this.floatKey]);
            }

            /**
             * @param {number} digits
             * @return {number}
             */

        }, {
            key: 'toFixed',
            value: function toFixed(digits) {
                digits = isNaN(+digits) ? 2 : +digits;

                var factor = Math.pow(10, digits);

                return Math.round(this[this.floatKey] * factor) / factor;
            }
        }, {
            key: '_parse',
            value: function _parse() {
                var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
                var fractionSeparator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.fractionPointer;

                var parsed = NaN,
                    separatorRegExp = new RegExp('[,' + fractionSeparator + ']', 'g');

                // устанавливам разделитель дробной части на дефолтный или заданный
                val = val.replace(separatorRegExp, '.').replace(/[^0-9\.-]/g, '');

                // нативный парсер
                parsed = parseFloat(val, 10);

                return parsed;
            }
        }, {
            key: '_setValue',
            value: function _setValue(val) {
                this[this.floatKey] = val;
                this[this.intKey] = val > 0 ? Math.floor(val) : Math.ceil(val);
                this[this.fractionKey] = +(val % 1).toFixed(6);
            }

            /**
             * @return {boolean}
             */

        }, {
            key: 'isNull',
            value: function isNull() {
                console.warn('INumber prototype.isNull() is deprecated. Use .toFloat().');
                return this[this.floatKey] === 0;
            }

            /**
             * @return {number}
             */

        }, {
            key: 'toNumber',
            value: function toNumber() {
                console.warn('INumber prototype.toNumber() is deprecated. Use .toFloat().');
                return this[this.floatKey];
            }
        }, {
            key: 'toHtml',
            value: function toHtml(fractionPointer, thousandPointer, htmlTag, shortFormat, toFixed, toABS) {
                console.warn('INumber prototype.toHtml() is deprecated. Use .toString().');
                return this.toString(fractionPointer, thousandPointer, shortFormat, toFixed, toABS);
            }
        }, {
            key: 'isDefault',
            value: function isDefault() {
                console.warn('INumber prototype.isDefault() is deprecated.');
                return false;
            }
        }, {
            key: 'is',
            value: function is() {
                console.warn('INumber prototype.is() is deprecated. Use .toFloat().');
                return false;
            }
        }]);

        return INumber;
    }();

    return INumber;
});